import { createContext } from 'react';
import { StoryblokNode } from '../interfaces/StoryblokNode.interface';
import { StoryblokArticleAuthor } from '../interfaces/StoryblokArticleAuthor.interface';

interface ArticleContextProps {
  category_tags?: string[];
  subcategory_tags?: string[];
  authors: StoryblokNode<StoryblokArticleAuthor>[];
  readTime?: string;
  publishedDateOverride?: string;
  updatedDateOverride?: string;
  publishedAt: string;
  updatedDate?: string;
}

export const ArticleContext = createContext<ArticleContextProps>({
  category_tags: [],
  subcategory_tags: [],
  authors: [],
  readTime: undefined,
  publishedDateOverride: undefined,
  updatedDateOverride: undefined,
  publishedAt: '',
  updatedDate: '',
});
